import { $, $$, show, esc, nf, postQuote } from './_helpers'

const { __, sprintf } = wp.i18n

// Expert request: steps, validation, collection, sending.
export const initExpert = () => {
  const OPT = window.vnQuote.options
  const FORM_TOKEN = window.vnQuote.token
  const PRESELECT = window.vnQuote.preselect
  const PHONE = window.vnQuote.phone

  const steps = $$('#quoteForm .step')
  let cur = 0
  const state = { family: '', type: '' }
  const elementCache = {} // values changed by the customer per element, kept if the structure changes

  const nextLabel = (i) =>
    i === steps.length - 1 ? __('Send my request', 'vn') : __('Next →', 'vn')

  /* ── Navigation ─────────────────────────────────────────── */
  $('#progress').innerHTML = steps
    .map((s) => `<div><span>${esc(s.dataset.title)}</span></div>`)
    .join('')
  function go(i) {
    if (i === 3) renderElements()
    steps.forEach((s, k) => show(s, k === i))
    cur = i
    $$('#progress div').forEach((d, k) => d.classList.toggle('done', k <= i))
    $('#stepLabel').textContent = sprintf(
      /* translators: 1: step number, 2: number of steps, 3: step title */
      __('Step %1$d of %2$d — %3$s', 'vn'),
      i + 1,
      steps.length,
      steps[i].dataset.title
    )
    $('#prev').style.visibility = i === 0 ? 'hidden' : 'visible'
    $('#next').textContent = nextLabel(i)
    show($('#globalErr'), false)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
  // the Shaping step (index 4) is skipped when the product has nothing to offer
  const skipStep = (i) => i === 4 && !hasShaping()
  $('#prev').onclick = () => go(skipStep(cur - 1) ? cur - 2 : cur - 1)
  $('#next').onclick = () => {
    if (!validateStep(cur)) return
    if (cur === steps.length - 1) return submit()
    go(skipStep(cur + 1) ? cur + 2 : cur + 1)
  }

  /* ── Step 2: family / type ──────────────────────────────── */
  function selectProduct(fam, type) {
    state.family = fam
    state.type = type
    $$('#products .tile').forEach((t) =>
      t.classList.toggle('on', t.dataset.type === type)
    )
    applyProduct()
  }
  $$('#products .tile').forEach(
    (t) => (t.onclick = () => selectProduct(t.dataset.family, t.dataset.type))
  )

  /* What the product offers (Vn_Quote_Options::profiles(), Website settings > Quote request > Products) */
  const prof = () => OPT.profiles[state.type] || OPT.profiles.autre || {}
  const isBrochure = () => !!prof().pages
  const isFolded = () => !!prof().open
  function hasShaping() {
    const p = prof()
    return !!(p.binding || p.fold || p.cutting || p.flat || p.corners)
  }

  function fillFormats(p) {
    const sel = $('#formatPreset'),
      prev = sel.value
    const keys =
      p.formats && p.formats.length ? p.formats : Object.keys(OPT.formats)
    sel.innerHTML =
      `<option value="">${esc(__('— Choose —', 'vn'))}</option>` +
      keys
        .map(
          (k) =>
            `<option value="${k}" data-w="${OPT.formats[k].w}" data-h="${OPT.formats[k].h}">${esc(OPT.formats[k].label)}</option>`
        )
        .join('') +
      `<option value="custom">${esc(__('Custom format', 'vn'))}</option>`
    if (keys.includes(prev) || prev === 'custom') sel.value = prev
    else {
      $('#fw').value = ''
      $('#fh').value = ''
    }
  }

  function applyProduct() {
    const p = prof()
    show($('#descBox'), state.family === 'autre')
    show($('#openBox'), !!p.open)
    show($('#pagesBox'), !!p.pages)
    show($('#bindingBox'), !!p.binding)
    $('#bindingBox label').classList.toggle('req', !!p.pages)
    if (!p.binding) $('#binding').value = ''
    show($('#foldBox'), !!p.fold)
    if (!p.fold) $('[data-k="finishing.fold"]').value = ''
    show($('#cornersBox'), !!p.corners)
    if (!p.corners) $('[data-k="finishing.corners"]').checked = false
    show($('#cuttingField'), !!p.cutting)
    if (p.cutting === 'auto') {
      $('#cutting').checked = true
      show($('#cuttingBox'), true)
    }
    if (!p.cutting) {
      $('#cutting').checked = false
      show($('#cuttingBox'), false)
    }
    show($('#flatBox'), !!p.flat)
    if (!p.flat) $('[data-k="finishing.flat"]').checked = false
    $('#formatLegend').textContent = p.pages
      ? __('Finished format (closed)', 'vn')
      : __('Finished format', 'vn')
    show($('#formatHint'), !!p.pages)
    fillFormats(p)
  }

  /* ── Step 3: format ─────────────────────────────────────── */
  $('#formatPreset').onchange = (e) => {
    const o = e.target.selectedOptions[0]
    if (o.dataset.w) {
      $('#fw').value = o.dataset.w
      $('#fh').value = o.dataset.h
    }
    if (e.target.value === 'custom') {
      $('#fw').value = ''
      $('#fh').value = ''
      $('#fw').focus()
    }
  }
  ;['#fw', '#fh'].forEach(
    (s) =>
      ($(s).oninput = () => {
        $('#formatPreset').value = 'custom'
      })
  )

  /* ── Quantities ─────────────────────────────────────────── */
  function addQty(v = '') {
    const r = document.createElement('div')
    r.className = 'pt-quote__row'
    r.innerHTML = `<input type="number" min="1" class="qty" placeholder="${esc(__('Number of copies', 'vn'))}" value="${esc(v)}"><button type="button" class="pt-quote__remove" title="${esc(__('Remove', 'vn'))}">×</button>`
    r.querySelector('.pt-quote__remove').onclick = () => {
      if ($$('.qty').length > 1) r.remove()
    }
    $('#qtyList').append(r)
  }
  addQty()
  $('#addQty').onclick = () => addQty()

  /* ── Versions ───────────────────────────────────────────── */
  $('#multiVersions').onchange = (e) => {
    show($('#versionsBox'), e.target.checked)
    versionMode()
  }
  $$('input[name=vmode]').forEach((r) => (r.onchange = versionMode))
  function versionMode() {
    const m = $('input[name=vmode]:checked').value
    show($('#vEqual'), m === 'equal')
    show($('#vDetail'), m === 'detail')
    if (m === 'detail' && !$$('#vRows .pt-quote__row').length) {
      addVersion()
      addVersion()
    }
    updateVersionTotal()
  }
  function addVersion(name = '', qty = '') {
    const n = $$('#vRows .pt-quote__row').length + 1
    const r = document.createElement('div')
    r.className = 'pt-quote__row'
    /* translators: %d: version number */
    const placeholder = sprintf(__('Name (e.g. Var, Monaco…) — Version %d', 'vn'), n)
    r.innerHTML = `<input type="text" class="vname" placeholder="${esc(placeholder)}" value="${esc(name)}">
                   <input type="number" min="1" class="vqty" placeholder="${esc(__('Copies', 'vn'))}" value="${esc(qty)}">
                   <button type="button" class="pt-quote__remove" title="${esc(__('Remove', 'vn'))}">×</button>`
    r.querySelector('.pt-quote__remove').onclick = () => {
      r.remove()
      updateVersionTotal()
    }
    r.querySelector('.vqty').oninput = updateVersionTotal
    $('#vRows').append(r)
  }
  $('#addVersion').onclick = () => addVersion()
  ;['#vCount', '#vQty'].forEach((s) => ($(s).oninput = updateVersionTotal))
  function versionList() {
    if (!$('#multiVersions').checked) return []
    if ($('input[name=vmode]:checked').value === 'equal') {
      const n = Math.min(+$('#vCount').value || 0, 500),
        q = +$('#vQty').value || 0
      return n > 1 ? Array.from({ length: n }, () => ({ name: '', qty: q })) : []
    }
    return $$('#vRows .pt-quote__row').map((r) => ({
      name: $('.vname', r).value.trim(),
      qty: +$('.vqty', r).value || 0,
    }))
  }
  function updateVersionTotal() {
    const l = versionList(),
      tot = l.reduce((s, v) => s + v.qty, 0)
    $('#vTotal').textContent =
      l.length > 1 && tot
        ? /* translators: 1: number of versions, 2: total of copies */
          sprintf(__('%1$d versions — total %2$s copies', 'vn'), l.length, nf(tot))
        : ''
    // Only one quantity entered: it is aligned on the total of the versions
    const q = $$('.qty')
    if (tot && q.length === 1) q[0].value = tot
  }

  /* ── Step 4: elements (paper + printing) ────────────────── */
  function elementDefs() {
    if (!isBrochure()) return [{ id: 'support', name: __('Support', 'vn') }]
    const cover = $('#coverType').value,
      pages = +$('#pagesInterior').value || null
    const d = []
    if (cover !== 'self') d.push({ id: 'couverture', name: __('Cover', 'vn'), pages: 4 })
    d.push({ id: 'interieur', name: __('Interior', 'vn'), pages })
    if (cover === '4p_sur')
      d.push({ id: 'surcouverture', name: __('Over-cover', 'vn'), pages: 4, withQty: true })
    return d
  }
  const opts = (o, sel) =>
    Object.entries(o)
      .map(
        ([k, v]) =>
          `<option value="${k}" ${k == sel ? 'selected' : ''}>${esc(v)}</option>`
      )
      .join('')

  // all = also the untouched elements (sending); otherwise they take the product preselection again
  function cacheElements(all = false) {
    $$('#elements .element').forEach((el) => {
      if (!all && !('touched' in el.dataset)) {
        delete elementCache[el.dataset.id]
        return
      }
      const v = {}
      $$('[data-e]', el).forEach(
        (i) => (v[i.dataset.e] = i.type === 'checkbox' ? i.checked : i.value)
      )
      elementCache[el.dataset.id] = v
    })
  }
  const FIN_LABELS = {
    lamination: __('lamination', 'vn'),
    spotVarnish: __('varnish', 'vn'),
    hotFoil: __('hot foil', 'vn'),
    scoring: __('scoring', 'vn'),
  }
  const hasFin = (c) => (prof().finishes || []).some((k) => !!c[k])
  function finBlock(d, c) {
    const F = prof().finishes || []
    if (!F.length) return ''
    const has = (k) => F.includes(k)
    /* translators: %s: list of finishes */
    const toggleLabel = sprintf(__('+ Add a finish (%s)', 'vn'), F.map((k) => FIN_LABELS[k]).join(', '))
    /* translators: %s: element name */
    const finTitle = sprintf(__('Finishes: %s', 'vn'), d.name.toLowerCase())
    return `<button type="button" class="pt-quote__link e-fin-toggle${hasFin(c) ? ' d-none' : ''}">${esc(toggleLabel)}</button>
      <div class="e-fin${hasFin(c) ? '' : ' d-none'}">
        <div class="lbl">${esc(finTitle)}</div>
        <div class="pt-quote__grid">
          ${
            has('lamination')
              ? `<div class="field"><label>${esc(__('Lamination', 'vn'))}</label><select data-e="lamination"><option value="">${esc(__('— None —', 'vn'))}</option>${opts(OPT.laminations, c.lamination)}</select></div>
          <div class="field e-lamsides d-none"><label>${esc(__('Lamination on', 'vn'))}</label><select data-e="laminationSides">${opts(OPT.sides, c.laminationSides)}</select></div>`
              : ''
          }
          ${has('spotVarnish') ? `<div class="field"><label>${esc(__('Spot varnish', 'vn'))}</label><select data-e="spotVarnish"><option value="">${esc(__('— None —', 'vn'))}</option>${opts(OPT.sides, c.spotVarnish)}</select></div>` : ''}
        </div>
        ${has('hotFoil') ? `<label class="chk"><input type="checkbox" data-e="hotFoil" ${c.hotFoil ? 'checked' : ''}> ${esc(__('Hot foil stamping', 'vn'))}</label>` : ''}
        ${
          has('scoring')
            ? `<label class="chk e-scoring d-none"><input type="checkbox" data-e="scoring" ${c.scoring ? 'checked' : ''}> ${esc(__('Scoring', 'vn'))}</label>
        <p class="hint e-scoring-off d-none">${esc(sprintf(/* translators: %s: grammage */ __('Scoring possible from %s g/m².', 'vn'), OPT.scoringMin))}</p>`
            : ''
        }
      </div>`
  }
  function renderElements() {
    cacheElements()
    $('#elements').innerHTML = elementDefs()
      .map((d) => {
        const c = elementCache[d.id] || {
          type: prof().paper,
          grammage: prof().grammage,
          recto: 'quadri',
          verso: d.id === 'support' ? 'aucune' : 'quadri',
        }
        /* translators: %s: number of pages */
        const pagesLabel = d.pages ? ' — ' + sprintf(__('%s pages', 'vn'), d.pages) : ''
        return `<div class="element" data-id="${d.id}" data-name="${esc(d.name)}" data-pages="${d.pages || ''}"${elementCache[d.id] ? ' data-touched' : ''}>
      <h3>${esc(d.name)}${esc(pagesLabel)}</h3>
      ${d.withQty ? `<div class="field mb-3" style="max-width:280px"><label>${esc(__('On how many copies?', 'vn'))}</label><input type="number" min="1" data-e="qty" value="${esc(c.qty || '')}"></div>` : ''}
      <div class="pt-quote__grid">
        <div class="field"><label class="req">${esc(__('Paper type', 'vn'))}</label><select data-e="type">${opts(OPT.papers, c.type)}<option value="conseil" ${c.type === 'conseil' ? 'selected' : ''}>${esc(__('I don\'t know / advise me', 'vn'))}</option></select></div>
        <div class="field"><label class="req">${esc(__('Grammage', 'vn'))}</label><select data-e="grammage">
          <option value="">${esc(__('— Choose —', 'vn'))}</option>
          ${OPT.grammages.map((g) => `<option value="${g}" ${g == c.grammage ? 'selected' : ''}>${g} g/m²</option>`).join('')}
          <option value="autre" ${c.grammage === 'autre' ? 'selected' : ''}>${esc(__('Other grammage', 'vn'))}</option>
          <option value="conseil" ${c.grammage === 'conseil' ? 'selected' : ''}>${esc(__('I don\'t know / advise me', 'vn'))}</option></select></div>
        <div class="field e-gother d-none"><label>${esc(__('Requested grammage (g/m²)', 'vn'))}</label><input type="number" min="40" max="600" data-e="grammageOther" value="${esc(c.grammageOther || '')}"></div>
        <div class="field e-prec d-none"><label>${esc(__('Specify (reference, texture, colour…)', 'vn'))}</label><input type="text" data-e="precision" value="${esc(c.precision || '')}"></div>
      </div>
      <label class="chk"><input type="checkbox" data-e="recycled" ${c.recycled ? 'checked' : ''}> ${esc(__('Recycled paper', 'vn'))}</label>
      <div class="pt-quote__grid mt-2">
        <div class="field"><label>${esc(__('Front printing', 'vn'))}</label><select data-e="recto">${opts(OPT.printing, c.recto)}</select></div>
        <div class="field"><label>${esc(__('Back printing', 'vn'))}</label><select data-e="verso">${opts(OPT.printing, c.verso)}</select></div>
        <div class="field e-pantone d-none"><label>${esc(__('Pantone reference(s)', 'vn'))}</label><input type="text" data-e="pantone" placeholder="${esc(__('E.g. 185 C', 'vn'))}" value="${esc(c.pantone || '')}"></div>
      </div>
      ${finBlock(d, c)}
    </div>`
      })
      .join('')
    $$('#elements .element').forEach((el) => {
      const sync = () => {
        show($('.e-gother', el), $('[data-e=grammage]', el).value === 'autre')
        show($('.e-prec', el), ['creation', 'autre'].includes($('[data-e=type]', el).value))
        show(
          $('.e-pantone', el),
          [$('[data-e=recto]', el).value, $('[data-e=verso]', el).value].some((v) =>
            v.includes('pantone')
          )
        )
        show($('.e-lamsides', el), !!$('[data-e=lamination]', el)?.value)
        // scoring: only if the known grammage reaches the minimum
        const gv = $('[data-e=grammage]', el).value
        const gnum = gv === 'autre' ? +$('[data-e=grammageOther]', el).value : +gv
        const canScore = gnum >= OPT.scoringMin
        show($('.e-scoring', el), canScore)
        show($('.e-scoring-off', el), !canScore && gnum > 0)
        if (!canScore && $('[data-e=scoring]', el)) $('[data-e=scoring]', el).checked = false
      }
      $$('select', el).forEach((s) => s.addEventListener('change', sync))
      const touch = () => el.setAttribute('data-touched', '')
      el.addEventListener('change', touch)
      el.addEventListener('input', touch)
      $('[data-e=grammageOther]', el).addEventListener('input', sync)
      const tg = $('.e-fin-toggle', el)
      if (tg)
        tg.onclick = () => {
          show($('.e-fin', el), true)
          show(tg, false)
        }
      sync()
    })
  }

  /* ── Step 5 ─────────────────────────────────────────────── */
  $('#cutting').onchange = (e) => show($('#cuttingBox'), e.target.checked)

  /* ── Step 6: delivery ───────────────────────────────────── */
  $$('input[name=dmode]').forEach(
    (r) =>
      (r.onchange = () =>
        show($('#pointsBox'), $('input[name=dmode]:checked').value === 'delivery'))
  )
  function addPoint() {
    const r = document.createElement('div')
    r.className = 'pt-quote__row point'
    r.innerHTML = `<input type="text" class="pcp" placeholder="${esc(__('Postal code', 'vn'))}" maxlength="10">
                   <input type="text" class="pcity" placeholder="${esc(__('City', 'vn'))}">
                   <input type="number" min="1" class="pqty" placeholder="${esc(__('Qty (if several points)', 'vn'))}">
                   <button type="button" class="pt-quote__remove" title="${esc(__('Remove', 'vn'))}">×</button>`
    r.querySelector('.pt-quote__remove').onclick = () => {
      if ($$('.point').length > 1) r.remove()
    }
    $('#points').append(r)
  }
  addPoint()
  $('#addPoint').onclick = addPoint
  $('#ddate').min = new Date().toISOString().slice(0, 10)

  /* ── Validation per step ────────────────────────────────── */
  function mark(el, msg) {
    el.classList.add('invalid')
    const m = document.createElement('div')
    m.className = 'err-msg'
    m.textContent = msg
    ;(el.closest('.field') || el.parentElement).append(m)
  }
  function validateStep(i) {
    const s = steps[i]
    $$('.invalid', s).forEach((e) => e.classList.remove('invalid'))
    $$('.err-msg', s).forEach((e) => e.remove())
    const errs = [] // [message, shown in the global error]
    const need = (el, msg, global = false) => {
      if (el && el.offsetParent !== null && !String(el.value).trim()) {
        mark(el, msg)
        errs.push([msg, global])
      }
    }

    if (i === 0) {
      $$('[required]', s).forEach((el) => need(el, __('Required field', 'vn')))
      const em = $('[data-k="contact.email"]')
      if (em.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em.value)) {
        mark(em, __('Invalid email', 'vn'))
        errs.push(['email', false])
      }
      const si = $('[data-k="contact.siret"]'),
        d = si.value.replace(/\D/g, '')
      if (d && d.length !== 14) {
        mark(si, __('14 digits', 'vn'))
        errs.push(['siret', false])
      }
    }
    if (i === 1) {
      if (!state.type) errs.push([__('Choose a product from the list', 'vn'), true])
      if (state.family === 'autre')
        need($('[data-k="product.description"]'), __('Describe your project', 'vn'), true)
    }
    if (i === 2) {
      if (state.family !== 'autre') {
        need($('#fw'), __('Width?', 'vn'))
        need($('#fh'), __('Height?', 'vn'))
      }
      if (isBrochure()) need($('#pagesInterior'), __('Number of pages?', 'vn'))
      if (!$$('.qty').some((q) => +q.value > 0)) {
        mark($$('.qty')[0], __('Quantity?', 'vn'))
        errs.push(['qty', false])
      }
      if ($('#multiVersions').checked && versionList().length < 2)
        errs.push([__('Enter at least 2 versions', 'vn'), true])
    }
    if (i === 3) {
      $$('#elements [data-e=grammage]').forEach((g) =>
        need(
          g,
          /* translators: %s: element name */
          sprintf(__('Choose a grammage for: %s', 'vn'), g.closest('.element').dataset.name),
          true
        )
      )
    }
    if (i === 4 && isBrochure()) need($('#binding'), __('Choose a binding', 'vn'), true)
    if (i === 5 && $('input[name=dmode]:checked').value === 'delivery') {
      const cp = $$('.pcp')
      if (!cp.some((c) => c.value.trim())) {
        mark(cp[0], __('Postal code?', 'vn'))
        errs.push(['cp', false])
      }
    }
    if (errs.length) {
      const g = $('#globalErr')
      const details = errs.filter(([, global]) => global).map(([msg]) => msg)
      g.textContent =
        __('Please complete the highlighted fields.', 'vn') +
        (details.length ? ' ' + details.join('. ') : '')
      show(g, true)
      const first = $('.invalid', s)
      if (first) {
        first.scrollIntoView({ behavior: 'smooth', block: 'center' })
        first.focus({ preventScroll: true })
      }
    }
    return !errs.length
  }

  ;['input', 'change'].forEach((ev) =>
    document.addEventListener(ev, (e) => {
      const el = e.target
      if (!el.classList || !el.classList.contains('invalid') || !String(el.value).trim())
        return
      el.classList.remove('invalid')
      ;(el.closest('.field') || el.parentElement)
        .querySelectorAll('.err-msg')
        .forEach((m) => m.remove())
      if (!$('.invalid', steps[cur])) show($('#globalErr'), false)
    })
  )

  /* ── Collection and sending ─────────────────────────────── */
  function setPath(o, path, v) {
    const k = path.split('.')
    let t = o
    k.slice(0, -1).forEach((p) => (t = t[p] ??= {}))
    t[k.at(-1)] = v
  }
  function collect() {
    cacheElements(true)
    const d = {
      website: $('#quoteForm input[name=vn_extra_field]').value,
      formToken: FORM_TOKEN,
    }
    $$('[data-k]').forEach((el) =>
      setPath(d, el.dataset.k, el.type === 'checkbox' ? el.checked : el.value)
    )
    setPath(d, 'product.family', state.family)
    setPath(d, 'product.type', state.type)
    if (!isBrochure()) d.pages = {}
    if (!isFolded()) {
      d.format.openWidth = ''
      d.format.openHeight = ''
    }
    d.quantities = $$('.qty')
      .map((q) => +q.value)
      .filter(Boolean)
    d.versions = { list: versionList() }
    d.elements = $$('#elements .element').map((el) => {
      const v = elementCache[el.dataset.id]
      return {
        name: el.dataset.name,
        pages: +el.dataset.pages || null,
        qty: +v.qty || null,
        paper: {
          type: v.type,
          grammage: v.grammage,
          grammageOther: v.grammageOther,
          precision: v.precision,
          recycled: v.recycled,
        },
        printing: { recto: v.recto, verso: v.verso, pantone: v.pantone },
        finishing: {
          lamination: v.lamination,
          laminationSides: v.laminationSides,
          spotVarnish: v.spotVarnish,
          hotFoil: v.hotFoil,
          scoring: v.scoring,
        },
      }
    })
    d.files = { ready: 'oui' } // files ready without retouching by default
    d.finishing.cuttingForm = d.finishing.cutting
      ? $('input[name=cuttingForm]:checked').value
      : null
    d.delivery.mode = $('input[name=dmode]:checked').value
    d.delivery.points = $$('.point').map((r) => ({
      postalCode: $('.pcp', r).value.trim(),
      city: $('.pcity', r).value.trim(),
      qty: +$('.pqty', r).value || null,
    }))
    d.packaging = []
    return d
  }

  const ERR_STEP = { contact: 0, product: 1, format: 2, quantities: 2, delivery: 5 }
  async function submit() {
    const btn = $('#next')
    show($('#globalErr'), false)
    btn.disabled = true
    btn.textContent = __('Sending…', 'vn')
    try {
      const r = await postQuote(collect())
      if (r.ok) {
        steps.forEach((s) => show(s, false))
        show($('#nav'), false)
        show($('#progress'), false)
        show($('#stepLabel'), false)
        $('#doneRef').textContent = r.reference
        show($('#done'), true)
        window.scrollTo({ top: 0, behavior: 'smooth' })
        return
      }
      const errs = r.errors || {}
      const first = Object.keys(errs).find((k) => k !== '_global')
      if (first) go(ERR_STEP[first.split('.')[0]] ?? cur)
      $('#globalErr').textContent = Object.values(errs).join(' — ')
      show($('#globalErr'), true)
    } catch (e) {
      $('#globalErr').textContent = sprintf(
        /* translators: %s: phone number */
        __('Sending is not possible at the moment. Please try again or call us on %s.', 'vn'),
        PHONE
      )
      show($('#globalErr'), true)
    } finally {
      btn.disabled = false
      if ($('#done').classList.contains('d-none')) btn.textContent = nextLabel(cur)
    }
  }

  /* ── Preselection from a product page (?produit=flyer) ──── */
  if (PRESELECT) {
    for (const [fam, f] of Object.entries(OPT.families)) {
      if (f.types[PRESELECT]) {
        selectProduct(fam, PRESELECT)
        break
      }
    }
  }
  go(0)
}
